/*	
|--------------------------------------------------------------------------
| Template AppNexus Placement IDs: DFP
|--------------------------------------------------------------------------
*/
/**
 * @namespace --  
 */


var appNexusIds = {
	"default": {
		"heraldtribune.com": {"pid":"9430019"},
		"cantonrep.com": {
			"pid":	"9429933"
		},
		"capecodtimes.com": {
			"pid":	"9429937"
		},
		"gainesville.com": {
			"pid":	"9429995"
		},
		"pjstar.com": {
			"pid":	"9430120"
		},
		"recordonline.com": {
			"pid":	"9430135"
		},
		"seacoastonline.com": {
			"pid":	"9430147"
		},
		"sj-r.com": {
			"pid":	"9430154"
		},
		"starnewsonline.com": {
			"pid":	"9430163"
		},
		"telegram.com": {
			"pid":	"9430174"
		},
		"theledger.com": {
			"pid":	"9430185"
		},
		"providencejournal.com": {
			"pid":	"9529398"
		},
		"goerie.com": {"pid":"9894767"},
		"dispatch.com": {"pid":"9429458"},
		"ack.net": {"pid":"9429894"},
		"adelnews.com": {"pid":"9429895"},
		"advocatepress.com": {"pid":"9429896"},
		"agjournalonline.com": {"pid":"9429897"},
		"aledotimesrecord.com": {"pid":"9429898"},
		"alicetx.com": {"pid":"9429899"},
		"americanvalor.net": {"pid":"9429900"},
		"amestrib.com": {"pid":"9429901"},
		"amtrib.com": {"pid":"9429902"},
		"andoveramerican.com": {"pid":"9429903"},
		"apalachtimes.com": {"pid":"9429904"},
		"applevalley-review.com": {"pid":"9429905"},
		"ardmoreite.com": {"pid":"9429906"},
		"arkansasnews.com": {"pid":"9429907"},
		"weeklycitizen.com": {"pid":"9429908"},
		"augustagazette.com": {"pid":"9429909"},
		"auroraadvertiser.net": {"pid":"9429910"},
		"azcapitoltimes.com": {"pid":"9429911"},
		"ballingerledger.com": {"pid":"9429912"},
		"barnstablepatriot.com": {"pid":"9429913"},
		"bastropenterprise.com": {"pid":"9429914"},
		"bcdemocratonline.com": {"pid":"9429915"},
		"bedfordnow.com": {"pid":"9429916"},
		"bentoneveningnews.com": {"pid":"9429917"},
		"bignickel.com": {"pid":"9429918"},
		"bluejacketsxtra.com": {"pid":"9429919"},
		"blueridgenow.com": {"pid":"9429920"},
		"boonevilledemocrat.com": {"pid":"9429922"},
		"boonvilledailynews.com": {"pid":"9429923"},
		"bouldercityreview.com": {"pid":"9429924"},
		"brightonpittsfordpost.com": {"pid":"9429925"},
		"brownwoodtx.com": {"pid":"9429926"},
		"Buckeyextra.com": {"pid":"9429927"},
		"butlercountytimesgazette.com": {"pid":"9429928"},
		"cambridgechron.com": {"pid":"9429929"},
		"cantondailyledger.com": {"pid":"9429930"},
		"capecodonline.com": {"pid":"9429935"},
		"capecodrealestate.com": {"pid":"9429936"},
		"carmitimes.com": {"pid":"9429938"},
		"carthagepress.com": {"pid":"9429939"},
		"charlestonexpress.com": {"pid":"9429940"},
		"cheboygannews.com": {"pid":"9429941"},
		"chillicothenews.com": {"pid":"9429942"},
		"chillicothetimesbulletin.com": {"pid":"9429943"},
		"chipleypaper.com": {"pid":"9429944"},
		"chronicle-express.com": {"pid":"9429945"},
		"columbiadailyherald.com": {"pid":"9429946"},
		"columbusalive.com": {"pid":"9429947"},
		"columbusbride.com": {"pid":"9429948"},
		"columbusceo.com": {"pid":"9429949"},
		"columbuscrave.com": {"pid":"9429950"},
		"columbusmonthly.com": {"pid":"9429951"},
		"columbusparent.com": {"pid":"9429952"},
		"hockessincommunitynews.com": {"pid":"9429953"},
		"courier-tribune.com": {"pid":"9429954"},
		"crestviewbulletin.com": {"pid":"9429955"},
		"crookstontimes.com": {"pid":"9429956"},
		"dailyamericannews.com": {"pid":"9429957"},
		"dailycomet.com": {"pid":"9429958"},
		"dailycommercial.com": {"pid":"9429959"},
		"dailyregister.com": {"pid":"9429960"},
		"dailyreporter.com": {"pid":"9429961"},
		"dailyrepublicannews.com": {"pid":"9429962"},
		"dailytidings.com": {"pid":"9429963"},
		"dansvilleonline.com": {"pid":"9429964"},
		"deridderdailynews.com": {"pid":"9429965"},
		"desertdispatch.com": {"pid":"9429966"},
		"destin.com": {"pid":"9429967"},
		"devilslakejournal.com": {"pid":"9429968"},
		"djcgulfcoast.com": {"pid":"9429970"},
		"djcoregon.com": {"pid":"9429971"},
		"dodgeglobe.com": {"pid":"9429972"},
		"donaldsonvillechief.com": {"pid":"9429973"},
		"doverpost.com": {"pid":"9429974"},
		"duquoin.com": {"pid":"9429975"},
		"eastpeoriatimescourier.com": {"pid":"9429976"},
		"echo-pilot.com": {"pid":"9429977"},
		"edinburgreview.com": {"pid":"9429978"},
		"eglindispatch.com": {"pid":"9429979"},
		"eldoradotimes.com": {"pid":"9429980"},
		"elmojave.com": {"pid":"9429981"},
		"eltiempolv.com": {"pid":"9429982"},
		"emeraldcoast.com": {"pid":"9429983"},
		"enterprisenews.com": {"pid":"9429984"},
		"eveningtribune.com": {"pid":"9429985"},
		"examiner-enterprise.com": {"pid":"9429986"},
		"examiner.net": {"pid":"9429987"},
		"fairportpost.com": {"pid":"9429988"},
		"finance-commerce.com": {"pid":"9429989"},
		"fosters.com": {"pid":"9429990"},
		"fowlertribune.com": {"pid":"9429991"},
		"fridaynightohio.com": {"pid":"9429992"},
		"gadsdentimes.com": {"pid":"9429994"},
		"galesburg.com": {"pid":"9429996"},
		"galvanews.com": {"pid":"9429997"},
		"gastongazette.com": {"pid":"9429998"},
		"gateschilipost.com": {"pid":"9430000"},
		"gatorsports.com": {"pid":"9430001"},
		"geneseorepublic.com": {"pid":"9430002"},
		"goupstate.com": {"pid":"9430003"},
		"grandlakenews.com": {"pid":"9430004"},
		"granitefallsnews.com": {"pid":"9430005"},
		"greecepost.com": {"pid":"9430006"},
		"greenwooddemocrat.com": {"pid":"9430007"},
		"gridleyherald.com": {"pid":"9430008"},
		"grimestoday.com": {"pid":"9430009"},
		"gruperalv.com": {"pid":"9430010"},
		"gulfdefender.com": {"pid":"9430011"},
		"hamburgreporter.com": {"pid":"9430012"},
		"hannibal.net": {"pid":"9430013"},
		"havenews.com": {"pid":"9430014"},
		"helena-arkansas.com": {"pid":"9430015"},
		"henriettapost.com": {"pid":"9430016"},
		"herald-democrat.com": {"pid":"9430017"},
		"heraldnews.com": {"pid":"9430018"},
		"hesperiastar.com": {"pid":"9430020"},
		"hillsdale.net": {"pid":"9430021"},
		"hollandsentinel.com": {"pid":"9430022"},
		"homesplusmonroe.com": {"pid":"9430023"},
		"hopestar.com": {"pid":"9430024"},
		"houmatoday.com": {"pid":"9430025"},
		"hsvvoice.com": {"pid":"9430026"},
		"hurlburtwarrior.com": {"pid":"9430027"},
		"idahobusinessreview.com": {"pid":"9430028"},
		"indeonline.com": {"pid":"9430029"},
		"irondequoitpost.com": {"pid":"9430030"},
		"jacksonnewspapers.com": {"pid":"9430031"},
		"jdnews.com": {"pid":"9430032"},
		"journaldemocrat.com": {"pid":"9430033"},
		"journalrecord.com": {"pid":"9430034"},
		"journalstandard.com": {"pid":"9430035"},
		"kinston.com": {"pid":"9430036"},
		"kiowacountysignal.com": {"pid":"9430037"},
		"kirksvilledailyexpress.com": {"pid":"9430038"},
		"lajuntatribunedemocrat.com": {"pid":"9430039"},
		"lakesunleader.com": {"pid":"9430040"},
		"laredosbargainbook.com": {"pid":"9430041"},
		"leaderjournal.com": {"pid":"9430042"},
		"leavenworthtimes.com": {"pid":"9430043"},
		"leesvilledailyleader.com": {"pid":"9430044"},
		"lenconnect.com": {"pid":"9430045"},
		"libn.com": {"pid":"9430046"},
		"lincolncourier.com": {"pid":"9430047"},
		"linncountyleader.com": {"pid":"9430048"},
		"littlefallstimes.com": {"pid":"9430049"},
		"localmediagroupinc.com": {"pid":"9430050"},
		"lonokenews.net": {"pid":"9430051"},
		"lucernevalleyleader.com": {"pid":"9430052"},
		"luxurylv.com": {"pid":"9430053"},
		"lvbusinesspress.com": {"pid":"9430054"},
		"mackinacjournal.com": {"pid":"9430055"},
		"macombjournal.com": {"pid":"9430056"},
		"mailtribune.com": {"pid":"9430057"},
		"masslawyersweekly.com": {"pid":"9430058"},
		"masspoliticalnews.com": {"pid":"9430059"},
		"mcphersonsentinel.com": {"pid":"9430060"},
		"mecktimes.com": {"pid":"9430061"},
		"medfordnickel.com": {"pid":"9430062"},
		"metrowestdailynews.com": {"pid":"9430063"},
		"mexicoledger.com": {"pid":"9430064"},
		"miamiok.com": {"pid":"9430065"},
		"middletowntranscript.com": {"pid":"9430066"},
		"midlothianmirror.com": {"pid":"9430067"},
		"milawyersweekly.com": {"pid":"9430068"},
		"milfordbeacon.com": {"pid":"9430069"},
		"milforddailynews.com": {"pid":"9430070"},
		"minnlawyer.com": {"pid":"9430071"},
		"moberlymonitor.com": {"pid":"9430072"},
		"molawyersmedia.com": {"pid":"9430073"},
		"monroenews.com": {"pid":"9430074"},
		"monroeparent.com": {"pid":"9430075"},
		"monroetalks.com": {"pid":"9430076"},
		"montenews.com": {"pid":"9430077"},
		"morecontentnow": {"pid":"9430078"},
		"morningsun.net": {"pid":"9430079"},
		"mortontimesnews.com": {"pid":"9430080"},
		"moscowvillager.com": {"pid":"9430081"},
		"mpnnow.com": {"pid":"9430082"},
		"mtshastanews.com": {"pid":"9430083"},
		"nclawyersweekly.com": {"pid":"9430084"},
		"ncnewspress.com": {"pid":"9430085"},
		"neagle.com": {"pid":"9430086"},
		"Nemotrader.net": {"pid":"9430087"},
		"neoshodailynews.com": {"pid":"9430088"},
		"nevadaiowajournal.com": {"pid":"9430089"},
		"nevadapreps.com": {"pid":"9430090"},
		"newbernsj.com": {"pid":"9430091"},
		"neworleanscitybusiness.com": {"pid":"9430092"},
		"newportindependent.com": {"pid":"9430093"},
		"news-journalonline.com": {"pid":"9430094"},
		"news-star.com": {"pid":"9430095"},
		"newschief.com": {"pid":"9430096"},
		"newsherald.com": {"pid":"9430097"},
		"newssun.com": {"pid":"9430098"},
		"newstribune.info": {"pid":"9430099"},
		"wickedlocal.com/northofboston": {"pid":"9430100"},
		"northneighbornews.com": {"pid":"9430101"},
		"norwichbulletin.com": {"pid":"9430102"},
		"nwfdailynews.com": {"pid":"9430103"},
		"nydailyrecord.com": {"pid":"9430104"},
		"oakridger.com": {"pid":"9430105"},
		"ocala.com": {"pid":"9430106"},
		"ojornal.com": {"pid":"9430107"},
		"olneydailymail.com": {"pid":"9430108"},
		"oncape.com": {"pid":"9430109"},
		"oriongazette.com": {"pid":"9430110"},
		"pahrumpvalleytimes.com": {"pid":"9430111"},
		"paris-express.com": {"pid":"9430112"},
		"patriotledger.com": {"pid":"9430113"},
		"pawhuskajournalcapital.com": {"pid":"9430114"},
		"pbcommercial.com": {"pid":"9430115"},
		"pekintimes.com": {"pid":"9430116"},
		"penfieldpost.com": {"pid":"9430117"},
		"peopleforpeoplefund.com": {"pid":"9430118"},
		"picayune-times.com": {"pid":"9430119"},
		"poconorecord.com": {"pid":"9430121"},
		"politicsinminnesota.com": {"pid":"9430122"},
		"pontiacdailyleader.com": {"pid":"9430123"},
		"postsouth.com": {"pid":"9430124"},
		"poststarnews.com": {"pid":"9430125"},
		"prairiestateoutdoors.com": {"pid":"9430126"},
		"pratttribune.com": {"pid":"9430127"},
		"pressargus.com": {"pid":"9430128"},
		"pressmentor.com": {"pid":"9430129"},
		"progress-index.com": {"pid":"9430130"},
		"prosperpressnews.com": {"pid":"9430131"},
		"pulaskinews.net": {"pid":"9430132"},
		"randolphcountyheraldtribune.com": {"pid":"9430133"},
		"recordnet.com": {"pid":"9430134"},
		"recordstar.com": {"pid":"9430136"},
		"redwoodfallsgazette.com": {"pid":"9430137"},
		"reviewatlas.com": {"pid":"9430138"},
		"rhodeisland.com": {"pid":"9430139"},
		"ridgecrestca.com": {"pid":"9430140"},
		"rilawyersweekly.com": {"pid":"9430141"},
		"rockfordparent.com": {"pid":"9430142"},
		"rrstar.com": {"pid":"9430143"},
		"savingsenseonline.com": {"pid":"9430144"},
		"sclawyersweekly.com": {"pid":"9430145"},
		"scsuntimes.com": {"pid":"9430146"},
		"sekvoice.com": {"pid":"9430148"},
		"sentinel-standard.com": {"pid":"9430149"},
		"shelbystar.com": {"pid":"9430150"},
		"siftingsherald.com": {"pid":"9430151"},
		"siskiyoudaily.com": {"pid":"9430152"},
		"sitraders.com": {"pid":"9430153"},
		"sjnewsonline.com": {"pid":"9430155"},
		"sleepyeyenews.com": {"pid":"9430156"},
		"sooeveningnews.com": {"pid":"9430157"},
		"southcoasttoday.com": {"pid":"9430158"},
		"southlakepress.com": {"pid":"9430159"},
		"srpressgazette.com": {"pid":"9430160"},
		"starcourier.com": {"pid":"9430161"},
		"starfl.com": {"pid":"9430162"},
		"steubencourier.com": {"pid":"9430164"},
		"stjamesnews.com": {"pid":"9430165"},
		"storycityherald.com": {"pid":"9430166"},
		"sturgisjournal.com": {"pid":"9430167"},
		"stuttgartdailyleader.com": {"pid":"9430168"},
		"sulphurdailynews.com": {"pid":"9430169"},
		"sussexcountian.com": {"pid":"9430170"},
		"swtimes.com": {"pid":"9430171"},
		"taftmidwaydriller.com": {"pid":"9430172"},
		"tauntongazette.com": {"pid":"9430173"},
		"teutopolispress.com": {"pid":"9430175"},
		"the-dispatch.com": {"pid":"9430176"},
		"the-leader.com": {"pid":"9430177"},
		"thebag.com": {"pid":"9430178"},
		"thecarbondalenews.com": {"pid":"9430179"},
		"thedailyrecord.com": {"pid":"9430180"},
		"thedailyreporter.com": {"pid":"9430181"},
		"thedestinlog.com": {"pid":"9430182"},
		"thegurdontimes.com": {"pid":"9430183"},
		"thekansan.com": {"pid":"9430184"},
		"theperrychief.com": {"pid":"9430186"},
		"therecordherald.com": {"pid":"9430187"},
		"thered7.net": {"pid":"9430188"},
		"therolladailynews.com": {"pid":"9430189"},
		"thesuburbanite.com": {"pid":"9430190"},
		"thesuntimes.com": {"pid":"9430191"},
		"thetimesnews.com": {"pid":"9430192"},
		"thisweeknews.com": {"pid":"9430193"},
		"thisweeksports.com": {"pid":"9430194"},
		"tidesports.com": {"pid":"9430195"},
		"timesreporter.com": {"pid":"9430196"},
		"timestelegram.com": {"pid":"9430197"},
		"topsailadvertiser.com": {"pid":"9430198"},
		"tricountytimes.com": {"pid":"9430199"},
		"tuscaloosanews.com": {"pid":"9430200"},
		"uticaod.com": {"pid":"9430201"},
		"valawyersweekly.com": {"pid":"9430202"},
		"vanalstyneleader.net": {"pid":"9430203"},
		"vanburencountydem.com": {"pid":"9430204"},
		"victorpost.com": {"pid":"9430205"},
		"vvdailypress.com": {"pid":"9430206"},
		"waltonsun.com": {"pid":"9430207"},
		"washingtontimesreporter.com": {"pid":"9430209"},
		"waxahachietx.com": {"pid":"9430210"},
		"wayneindependent.com": {"pid":"9430211"},
		"waynepost.com": {"pid":"9430212"},
		"waynesvilledailyguide.com": {"pid":"9430213"},
		"websterpost.com": {"pid":"9430214"},
		"wellingtondailynews.com": {"pid":"9430215"},
		"wellsvilledaily.com": {"pid":"9430216"},
		"whitehalljournal.com": {"pid":"9430217"},
		"wickedlocal.com": {"pid":"9430219"},
		"wickedlocal.com/abington": {"pid":"9430220"},
		"wickedlocal.com/acton": {"pid":"9430221"},
		"wickedlocal.com/allston": {"pid":"9430222"},
		"wickedlocal.com/amesbury": {"pid":"9430223"},
		"wickedlocal.com/arlington": {"pid":"9430224"},
		"wickedlocal.com/ashland": {"pid":"9430225"},
		"wickedlocal.com/avon": {"pid":"9430226"},
		"wickedlocal.com/barnstable": {"pid":"9430227"},
		"wickedlocal.com/bedford": {"pid":"9430228"},
		"wickedlocal.com/bellingham": {"pid":"9430229"},
		"wickedlocal.com/belmont": {"pid":"9430230"},
		"wickedlocal.com/berkley": {"pid":"9430231"},
		"wickedlocal.com/beverly": {"pid":"9430232"},
		"wickedlocal.com/billerica": {"pid":"9430233"},
		"wickedlocal.com/bolton": {"pid":"9430234"},
		"wickedlocal.com/bourne": {"pid":"9430235"},
		"wickedlocal.com/boxborough": {"pid":"9430236"},
		"wickedlocal.com/boxford": {"pid":"9430237"},
		"wickedlocal.com/braintree": {"pid":"9430238"},
		"wickedlocal.com/brewster": {"pid":"9430239"},
		"wickedlocal.com/bridgewater": {"pid":"9430240"},
		"wickedlocal.com/bridgewatereast": {"pid":"9430241"},
		"wickedlocal.com/bridgewaterwest": {"pid":"9430242"},
		"wickedlocal.com/brockton": {"pid":"9430243"},
		"wickedlocal.com/brookline": {"pid":"9430244"},
		"wickedlocal.com/burlington": {"pid":"9430245"},
		"wickedlocal.com/cambridge": {"pid":"9430246"},
		"wickedlocal.com/canton": {"pid":"9430247"},
		"wickedlocal.com/capecod": {"pid":"9430248"},
		"wickedlocal.com/carver": {"pid":"9430249"},
		"wickedlocal.com/chatham": {"pid":"9430250"},
		"wickedlocal.com/chelmsford": {"pid":"9430251"},
		"wickedlocal.com/clinton": {"pid":"9430252"},
		"wickedlocal.com/cohasset": {"pid":"9430253"},
		"wickedlocal.com/concord": {"pid":"9430254"},
		"wickedlocal.com/danvers": {"pid":"9430255"},
		"wickedlocal.com/Dedham": {"pid":"9430256"},
		"wickedlocal.com/dennis": {"pid":"9430257"},
		"wickedlocal.com/dighton": {"pid":"9430258"},
		"wickedlocal.com/dover": {"pid":"9430259"},
		"wickedlocal.com/duxbury": {"pid":"9430260"},
		"wickedlocal.com/eastham": {"pid":"9430261"},
		"wickedlocal.com/easton": {"pid":"9430262"},
		"wickedlocal.com/essex": {"pid":"9430263"},
		"wickedlocal.com/fall-river": {"pid":"9430264"},
		"wickedlocal.com/falmouth": {"pid":"9430265"},
		"wickedlocal.com/foxborough": {"pid":"9430266"},
		"wickedlocal.com/framingham": {"pid":"9430267"},
		"wickedlocal.com/franklin": {"pid":"9430268"},
		"wickedlocal.com/georgetown": {"pid":"9430269"},
		"wickedlocal.com/gloucester": {"pid":"9430270"},
		"wickedlocal.com/halifax": {"pid":"9430271"},
		"wickedlocal.com/hamilton": {"pid":"9430272"},
		"wickedlocal.com/hanover": {"pid":"9430273"},
		"wickedlocal.com/hanson": {"pid":"9430274"},
		"wickedlocal.com/harvard": {"pid":"9430275"},
		"wickedlocal.com/harwich": {"pid":"9430276"},
		"wickedlocal.com/hingham": {"pid":"9430277"},
		"wickedlocal.com/holbrook": {"pid":"9430278"},
		"wickedlocal.com/holliston": {"pid":"9430279"},
		"wickedlocal.com/hopedale": {"pid":"9430280"},
		"wickedlocal.com/hopkinton": {"pid":"9430281"},
		"wickedlocal.com/hudson": {"pid":"9430282"},
		"wickedlocal.com/hull": {"pid":"9430283"},
		"wickedlocal.com/ipswich": {"pid":"9430284"},
		"wickedlocal.com/kingston": {"pid":"9430285"},
		"wickedlocal.com/lakeville": {"pid":"9430286"},
		"wickedlocal.com/lancaster": {"pid":"9430287"},
		"wickedlocal.com/lexington": {"pid":"9430288"},
		"wickedlocal.com/lincoln": {"pid":"9430289"},
		"wickedlocal.com/littleton": {"pid":"9430290"},
		"wickedlocal.com/malden": {"pid":"9430291"},
		"wickedlocal.com/manchester": {"pid":"9430292"},
		"wickedlocal.com/mansfield": {"pid":"9430293"},
		"wickedlocal.com/marblehead": {"pid":"9430294"},
		"wickedlocal.com/marion": {"pid":"9430295"},
		"wickedlocal.com/marlborough": {"pid":"9430296"},
		"wickedlocal.com/marshfield": {"pid":"9430297"},
		"wickedlocal.com/mashpee": {"pid":"9430298"},
		"wickedlocal.com/mattapoisett": {"pid":"9430299"},
		"wickedlocal.com/maynard": {"pid":"9430300"},
		"wickedlocal.com/medfield": {"pid":"9430301"},
		"wickedlocal.com/medford": {"pid":"9430302"},
		"wickedlocal.com/medway": {"pid":"9430303"},
		"wickedlocal.com/melrose": {"pid":"9430304"},
		"wickedlocal.com/mendon": {"pid":"9430305"},
		"wickedlocal.com/middleborough": {"pid":"9430306"},
		"wickedlocal.com/middleton": {"pid":"9430307"},
		"wickedlocal.com/milford": {"pid":"9430308"},
		"wickedlocal.com/millis": {"pid":"9430309"},
		"wickedlocal.com/milton": {"pid":"9430310"},
		"wickedlocal.com/natick": {"pid":"9430311"},
		"wickedlocal.com/needham": {"pid":"9430312"},
		"wickedlocal.com/newburyport": {"pid":"9430313"},
		"wickedlocal.com/newenglandarts": {"pid":"9430314"},
		"wickedlocal.com/newton": {"pid":"9430315"},
		"wickedlocal.com/norfolk": {"pid":"9430316"},
		"wickedlocal.com/northandover": {"pid":"9430317"},
		"wickedlocal.com/northattleborough": {"pid":"9430318"},
		"wickedlocal.com/northborough": {"pid":"9430319"},
		"wickedlocal.com/norton": {"pid":"9430320"},
		"wickedlocal.com/norwell": {"pid":"9430321"},
		"wickedlocal.com/norwood": {"pid":"9430322"},
		"wickedlocal.com/orleans": {"pid":"9430323"},
		"wickedlocal.com/pembroke": {"pid":"9430324"},
		"wickedlocal.com/plainville": {"pid":"9430325"},
		"wickedlocal.com/plymouth": {"pid":"9430326"},
		"wickedlocal.com/plympton": {"pid":"9430327"},
		"wickedlocal.com/provincetown": {"pid":"9430328"},
		"wickedlocal.com/quincy": {"pid":"9430329"},
		"wickedlocal.com/randolph": {"pid":"9430330"},
		"wickedlocal.com/raynham": {"pid":"9430331"},
		"wickedlocal.com/reading": {"pid":"9430332"},
		"wickedlocal.com/rehoboth": {"pid":"9430333"},
		"wickedlocal.com/rochester": {"pid":"9430334"},
		"wickedlocal.com/rockland": {"pid":"9430335"},
		"wickedlocal.com/rockport": {"pid":"9430336"},
		"wickedlocal.com/roslindale": {"pid":"9430337"},
		"wickedlocal.com/salem": {"pid":"9430338"},
		"wickedlocal.com/sandwich": {"pid":"9430339"},
		"wickedlocal.com/saugus": {"pid":"9430340"},
		"wickedlocal.com/scituate": {"pid":"9430341"},
		"wickedlocal.com/sharon": {"pid":"9430342"},
		"wickedlocal.com/sherborn": {"pid":"9430343"},
		"wickedlocal.com/shrewsbury": {"pid":"9430344"},
		"wickedlocal.com/somerset": {"pid":"9430345"},
		"wickedlocal.com/somerville": {"pid":"9430346"},
		"wickedlocal.com/southborough": {"pid":"9430347"},
		"wickedlocal.com/stoneham": {"pid":"9430348"},
		"wickedlocal.com/stoughton": {"pid":"9430349"},
		"wickedlocal.com/stow": {"pid":"9430350"},
		"wickedlocal.com/sudbury": {"pid":"9430351"},
		"wickedlocal.com/swampscott": {"pid":"9430352"},
		"wickedlocal.com/swansea": {"pid":"9430353"},
		"wickedlocal.com/taunton": {"pid":"9430354"},
		"wickedlocal.com/tewksbury": {"pid":"9430355"},
		"wickedlocal.com/topsfield": {"pid":"9430356"},
		"wickedlocal.com/truro": {"pid":"9430357"},
		"wickedlocal.com/upton": {"pid":"9430358"},
		"wickedlocal.com/wakefield": {"pid":"9430359"},
		"wickedlocal.com/walpole": {"pid":"9430360"},
		"wickedlocal.com/waltham": {"pid":"9430361"},
		"wickedlocal.com/wareham": {"pid":"9430362"},
		"wickedlocal.com/watertown": {"pid":"9430363"},
		"wickedlocal.com/wayland": {"pid":"9430364"},
		"wickedlocal.com/wellesley": {"pid":"9430365"},
		"wickedlocal.com/wellfleet": {"pid":"9430366"},
		"wickedlocal.com/wenham": {"pid":"9430367"},
		"wickedlocal.com/west-roxbury": {"pid":"9430368"},
		"wickedlocal.com/westborough": {"pid":"9430369"},
		"wickedlocal.com/westford": {"pid":"9430370"},
		"wickedlocal.com/weston": {"pid":"9430371"},
		"wickedlocal.com/westport": {"pid":"9430372"},
		"wickedlocal.com/westwood": {"pid":"9430373"},
		"wickedlocal.com/weymouth": {"pid":"9430374"},
		"wickedlocal.com/whitman": {"pid":"9430375"},
		"wickedlocal.com/wilmington": {"pid":"9430376"},
		"wickedlocal.com/winchester": {"pid":"9430377"},
		"wickedlocal.com/woburn": {"pid":"9430378"},
		"wickedlocal.com/wrentham": {"pid":"9430379"},
		"wickedlocal.com/yarmouth": {"pid":"9430380"},
		"wickedlocalparents.com": {"pid":"9430381"},
		"wickedlocalwebjams.com": {"pid":"9430382"},
		"wintersenterprise.com": {"pid":"9430383"},
		"wislawjournal.com": {"pid":"9430384"},
		"woodfordtimes.com": {"pid":"9430385"},
		"yourglenrosetx.com": {"pid":"9430386"},
		"yourstephenvilletx.com": {"pid":"9430387"},
		"yourvalleyvoice.com": {"pid":"9430388"}
	}
}
